import { style } from "@vanilla-extract/css";
import { calc } from "@vanilla-extract/css-utils";
import { breakpoints, vars } from "plos/src/styles";
import pattern1 from "../../../img/pattern/pattern-1-1236.png";

export const adobeTemplateImg = style({
  display: "block",
  margin: "auto",
  width: 300,

  "@media": {
    [`(min-width: ${breakpoints[1]})`]: {
      width: "75%",
      maxWidth: 500,
    },
  },
});

export const adobeImageContainer = style({
  // Negative margin to offset the padding of the dialog
  margin: `0 ${calc.negate(vars.space.m)}`,
  background: `${vars.colors.blueLilacGradient}`,
  selectors: {
    '[dir="rtl"] &': {
      background: `${vars.colors.blueLilacGradientRtl}`,
    },
  },
});

export const adobePatternContainer = style({
  background: `url(${pattern1})`,
  backgroundPosition: "left -50px bottom -300px",
  backgroundRepeat: "no-repeat",
  backgroundSize: "300px 500px",
  selectors: {
    '[dir="rtl"] &': {
      backgroundPosition: "right -50px bottom -300px",
      "@media": {
        [`(min-width: ${breakpoints[1]})`]: {
          backgroundPosition: "right -150px bottom -550px",
        },
      },
    },
  },
  "@media": {
    [`(min-width: ${breakpoints[1]})`]: {
      backgroundPosition: "left -150px bottom -550px",
      backgroundSize: "600px 1000px",
    },
  },
});

export const adobeTemplateButtonContainer = style({
  display: "flex",
  flexDirection: "column",
  gap: vars.space.xs,

  "@media": {
    [`(min-width: ${breakpoints[1]})`]: {
      flexDirection: "row",
    },
  },
});
